module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7bJma"))).then(() => module.bundle.root('d181N'));